module.exports = __webpack_public_path__ + "media/country_flags/ug-4ca0e1b1.png";